export const accountRoutes = [
  {
    path: "/account",
    component: () => import("@/views/Account/AccountBalance.vue"),
  },
];
